'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lio_intela_sites_intelacloud_content_Hero(eyebrow, title, lead, primary, secondary, footStrong, footText, panel) {
  this.hk = null;
  this.hr = null;
  this.hn = null;
  this.hp = null;
  this.hq = null;
  this.hl = null;
  this.hm = null;
  this.ho = null;
  this.hk = eyebrow;
  this.hr = title;
  this.hn = lead;
  this.hp = primary;
  this.hq = secondary;
  this.hl = footStrong;
  this.hm = footText;
  this.ho = panel;
}
export { $c_Lio_intela_sites_intelacloud_content_Hero as $c_Lio_intela_sites_intelacloud_content_Hero };
$p = $c_Lio_intela_sites_intelacloud_content_Hero.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lio_intela_sites_intelacloud_content_Hero;
/** @constructor */
function $h_Lio_intela_sites_intelacloud_content_Hero() {
}
export { $h_Lio_intela_sites_intelacloud_content_Hero as $h_Lio_intela_sites_intelacloud_content_Hero };
$h_Lio_intela_sites_intelacloud_content_Hero.prototype = $p;
$p.O = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.q = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().V(this, 185688047, true);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lio_intela_sites_intelacloud_content_Hero)) {
    if ((this.hk === x$0.hk)) {
      var x = this.hr;
      var x$2 = x$0.hr;
      var $x_3 = ((x === null) ? (x$2 === null) : x.f(x$2));
    } else {
      var $x_3 = false;
    }
    if (($x_3 && (this.hn === x$0.hn))) {
      var x$3 = this.hp;
      var x$4 = x$0.hp;
      var $x_2 = ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$5 = this.hq;
      var x$6 = x$0.hq;
      var $x_1 = ((x$5 === null) ? (x$6 === null) : x$5.f(x$6));
    } else {
      var $x_1 = false;
    }
    if ((($x_1 && (this.hl === x$0.hl)) && (this.hm === x$0.hm))) {
      var x$7 = this.ho;
      var x$8 = x$0.ho;
      return ((x$7 === null) ? (x$8 === null) : x$7.f(x$8));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.r = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().U(this);
});
$p.G = (function() {
  return 8;
});
$p.I = (function() {
  return "Hero";
});
$p.H = (function(n) {
  switch (n) {
    case 0: {
      return this.hk;
      break;
    }
    case 1: {
      return this.hr;
      break;
    }
    case 2: {
      return this.hn;
      break;
    }
    case 3: {
      return this.hp;
      break;
    }
    case 4: {
      return this.hq;
      break;
    }
    case 5: {
      return this.hl;
      break;
    }
    case 6: {
      return this.hm;
      break;
    }
    case 7: {
      return this.ho;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lio_intela_sites_intelacloud_content_Hero(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.bw)));
}
export { $isArrayOf_Lio_intela_sites_intelacloud_content_Hero as $isArrayOf_Lio_intela_sites_intelacloud_content_Hero };
var $d_Lio_intela_sites_intelacloud_content_Hero = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lio_intela_sites_intelacloud_content_Hero, "io.intela.sites.intelacloud.content.Hero", ({
  bw: 1,
  b: 1,
  e: 1,
  a: 1
}));
export { $d_Lio_intela_sites_intelacloud_content_Hero as $d_Lio_intela_sites_intelacloud_content_Hero };
//# sourceMappingURL=io.intela.sites.intelacloud.content.-Hero.js.map
